const routes = {
    path: 'expresso',
    name: 'Expressos_Painel',
    component: () => import('./Expresso.vue'),
    meta: {
        rules: ['EXPR-ATEN-00', 'EXPR-PAIN-00', 'EXPR-SALA-00'],
    },
};

export default routes;
